import React from "react";
import { setPhoneTemplate } from "../../actions/utiles";

function AdminListItem({ admin, onRemove }) {
  const getAuthorized = (authorized) => {
    const adminAuth = "관리책임자"
    switch (authorized) {
      case 2:
        return "운영담당자1";
  
      case 3:
        return "운영담당자2";
  
      default:
        return adminAuth;
    }
  };

  const getDate = (date) => {
    const newDate = new Date(date).toISOString().split("T")[0];
    return newDate;
  };

  return (
    <>
      <tr key={admin.id}>
        <th className="p-0">
          <span className="txt-dark-gray">{admin.name}</span>
        </th>
        <th className="p-0">
          <p className="mb-0 txt-dark-gray">{getAuthorized(admin.authorized)}</p>
        </th>
        <th className="p-0">
          <p className="mb-0 txt-dark-gray">{admin.email}</p>
        </th>
        <th className="p-0">
          <span className="txt-dark-gray">
            <p className="mb-0">{setPhoneTemplate(admin.phone_number)}</p>
          </span>
        </th>
        <th>
          <span className="txt-dark-gray">
            <p className="mb-0">{admin.department ? admin.department : "-"}</p>
          </span>
        </th>
        <th>
          <span className="txt-dark-gray">
            <p className="mb-0">{getDate(admin.assigned_date)}</p>
          </span>
        </th>
        <th className="p-0">
          <span>
            <button
              className="btn-white-sm pr-2 pl-2"
              onClick={() => onRemove(admin.id)}>
              삭제
            </button>
          </span>
        </th>
      </tr>
    </>
  );
}

export default AdminListItem;
